import { Box3, Object3D } from 'three'
import { ThreeItemKeys } from '../constants/three'

export const getGroupId = (object?: Object3D) =>
  object?.userData[ThreeItemKeys.GROUP_ID]

export const getGroupAssignedPrinterId = (object?: Object3D) =>
  object?.userData[ThreeItemKeys.ASSIGNED_PRINTER_ID]

export const isDxf2D = (object: Object3D) => {
  const box = new Box3()
  box.expandByObject(object)
  return (box.max.z - box.min.z) <= 0.20
}
